import React from "react";
import { Form } from "react-bootstrap";
import BasicRegistration from "./subcomponents/BasicRegistration";
import { labels } from "../../../localization/labels";
import SubmitButton from "../../core/SubmitButton";
import MessageAlert from "../../core/MessageAlert";
import { Affix } from "antd";

const Registration = props => {
  return (
    <div className="Registration">
      <Form onSubmit={props.onSubmit}>
        <BasicRegistration
          validation={props.validation}
          enablement={props.enablement}
          onChange={props.onChange}
        />

        <Affix offsetBottom={true}>
          <div className="bottom_bar">
            <SubmitButton
              className="buttonStyle"
              text={labels.registration}
              disabled={!props.isValid()}
              block
            />
          </div>
        </Affix>
      </Form>
      <MessageAlert ref={props.alertRef} className="LoginAlert" />
    </div>
  );
};

export default Registration;
